import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Phone, Mail, MapPin, ArrowRight, ExternalLink } from 'lucide-react';
import { AllcomLogo } from './Header';

const footerLinks = {
  soluciones: [
    { name: 'Autoservicio & Self-Checkout', href: '/soluciones/autoservicio-self-checkout' },
    { name: 'ESL / Precios Digitales', href: '/soluciones/esl-precios-digitales' },
    { name: 'Cartelería Digital', href: '/soluciones/carteleria-digital' },
    { name: 'Gestión de Filas', href: '/soluciones/gestion-filas' },
    { name: 'Aeropuertos', href: '/soluciones/aeropuertos' },
    { name: 'Pesaje Industrial', href: '/soluciones/pesaje-industrial' },
  ],
  servicios: [
    { name: 'Soporte 24/7', href: '/servicios/soporte-24-7' },
    { name: 'Programa Piloto', href: '/servicios/piloto' },
    { name: 'Arriendo & Leasing', href: '/servicios/arriendo-leasing' },
    { name: 'Implementación', href: '/servicios/implementacion-obras' },
    { name: 'Despliegues Masivos', href: '/servicios/despliegue-masivo' },
  ],
  empresa: [
    { name: 'Nosotros', href: '/empresa/nosotros' },
    { name: 'Historia', href: '/empresa/historia' },
    { name: 'Partners', href: '/empresa/partners' },
    { name: 'Certificaciones', href: '/empresa/certificaciones' },
    { name: 'Noticias', href: '/empresa/noticias' },
    { name: 'Casos de Éxito', href: '/casos' },
    { name: 'Novedades & Releases', href: '/novedades' },
  ]
};

export const Footer = () => (
  <footer className="bg-[#050E1F] text-white noise-texture" data-testid="footer" role="contentinfo">

    {/* Links */}
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-start">
        <div className="pt-0.5">
          <AllcomLogo variant="white" className="mb-6" />
          <p className="text-sm text-slate-400 mb-4">20 años de compromiso, creatividad y confiabilidad, para que tu tecnología funcione bien, todos los días.</p>
          <div className="space-y-2 text-sm text-slate-400">
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#0EA5E9]" /> +56 9 7529 4340</div>
            <div className="flex items-start gap-2"><Mail className="w-4 h-4 text-[#0EA5E9] mt-0.5" /><div>ventas@allcom.cl<br/>contacto@allcom.cl</div></div>
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#0EA5E9] mt-0.5" /><div>Andrés Bello 1567<br/>Providencia · Santiago · Chile</div></div>
          </div>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Soluciones</h4>
          <ul className="space-y-2">
            {footerLinks.soluciones.map(l => <li key={l.href}><Link to={l.href} className="text-sm text-slate-400 hover:text-[#0EA5E9] transition-colors">{l.name}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Servicios</h4>
          <ul className="space-y-2">
            {footerLinks.servicios.map(l => <li key={l.href}><Link to={l.href} className="text-sm text-slate-400 hover:text-[#0EA5E9] transition-colors">{l.name}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Empresa</h4>
          <ul className="space-y-2">
            {footerLinks.empresa.map(l => <li key={l.href}><Link to={l.href} className="text-sm text-slate-400 hover:text-[#0EA5E9] transition-colors">{l.name}</Link></li>)}
            <li><Link to="/empresa/informacion-corporativa" className="text-sm text-slate-400 hover:text-[#0EA5E9] transition-colors">Información Corporativa</Link></li>
          </ul>
        </div>
      </div>
    </div>

    {/* Bottom */}
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} ALLCOM™ S.A. Todos los derechos reservados.</p>
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-slate-500">
          <Link to="/empresa/informacion-corporativa" className="hover:text-[#0EA5E9] transition-colors">Información Corporativa</Link>
          <span className="hidden sm:inline">·</span>
          <a
            href="https://marioandres.cl"
            target="_blank"
            rel="me noopener noreferrer"
            className="inline-flex items-center gap-1 hover:text-[#0EA5E9] transition-colors"
            data-testid="footer-mario-backlink"
            title="Estrategia de IA liderada por Mario Andrés"
          >
            Estrategia de IA liderada por Mario Andrés <ExternalLink className="w-3 h-3" />
          </a>
          <span className="hidden sm:inline">·</span>
          <a
            href="/humans.txt"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#0EA5E9] transition-colors"
            data-testid="footer-humans-link"
          >humans.txt</a>
          <span className="hidden sm:inline">·</span>
          <span>Andrés Bello 1567 · Providencia · Santiago · Chile</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
